import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';
import { fullArticles } from '@/mocks/article';

const articleSlugs = Object.keys(fullArticles);

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-file-list-3-line text-lg text-background-50"></i>
              </div>
              <span className="text-lg font-heading font-bold text-background-50">
                Kakobuy <span className="text-primary-400">Polska</span>
              </span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed mt-3">
              Twoje centrum najlepszych znalezisk produktowych. Znajduj popularne produkty szybciej dzięki aktualnym listom Kakobuy Spreadsheet.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">Szybkie linki</h4>
            <ul className="space-y-3">
              <li>
                <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  Kakobuy Spreadsheet
                </a>
              </li>
              <li>
                <Link to="/#kategorie" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  Kategorie produktów
                </Link>
              </li>
              {articleSlugs.slice(0, 3).map((slug) => {
                const article = fullArticles[slug];
                return (
                  <li key={slug}>
                    <Link to={`/artykul/${slug}`} className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                      {article.h1.slice(0, 40)}...
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">Popularne kategorie</h4>
            <ul className="space-y-3">
              <li>
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  Buty
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  Bluzy / Swetry
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  Koszulki
                </a>
              </li>
              <li>
                <a href="https://kaspreadsheet.com/search-914/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-400 hover:text-primary-400 transition-colors">
                  Kurtki
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">Zaufanie</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm text-foreground-400">
                <i className="ri-check-line text-accent-500 mt-0.5"></i>
                <span>Aktualne listy produktów</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-400">
                <i className="ri-check-line text-accent-500 mt-0.5"></i>
                <span>Poradniki dla początkujących</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-400">
                <i className="ri-check-line text-accent-500 mt-0.5"></i>
                <span>Analiza bezpieczeństwa</span>
              </li>
              <li className="flex items-start gap-2 text-sm text-foreground-400">
                <i className="ri-check-line text-accent-500 mt-0.5"></i>
                <span>Darmowy dostęp</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Kakobuy Polska. Wszelkie prawa zastrzeżone.
          </p>
          <div className="flex items-center gap-6">
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors">
              Kakobuy Spreadsheet
            </a>
            <Link to="/artykul/kakobuy-spreadsheet-kompletny-przewodnik" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors">
              Poradnik
            </Link>
            <Link to="/artykul/kakobuy-bezpieczenstwo" className="text-xs text-foreground-500 hover:text-primary-400 transition-colors">
              Bezpieczeństwo
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}